var map = {
	"./01.png": "4815",
	"./02.png": "52b9",
	"./03.png": "0603",
	"./arrow-right-on.png": "1821",
	"./arrow-right.png": "6b33",
	"./banner-font.png": "8b69",
	"./bg-banner.png": "b5b9",
	"./bg-certification.png": "069f",
	"./bg-compliance-1.png": "5b74",
	"./bg-compliance-2.png": "46d1",
	"./bg-compliance-3.png": "36f1",
	"./bg-compliance-4.png": "5f84",
	"./bg-cost.png": "786c",
	"./bg-flow.png": "9f72",
	"./bg-operation-item-1.png": "b656",
	"./bg-operation-item-2.png": "3dd1",
	"./bg-plan-item-1.png": "dc08",
	"./bg-plan-item-2.png": "a580",
	"./bg-plan-item-3.png": "a319",
	"./bg-relation.png": "a8e5",
	"./puzzle-icon-1.png": "588d",
	"./puzzle-icon-2.png": "1542",
	"./puzzle-icon-3.png": "36c6",
	"./puzzle-icon-4.png": "f555",
	"./solution-icon-1.png": "051f",
	"./solution-icon-2.png": "9661",
	"./solution-icon-3.png": "0be7",
	"./solution-icon-4.png": "6702"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ce4";